import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getLanguageHeaderStyles = (theme: Theme): SerializedStyles =>
    css({
        paddingLeft: theme.spacing(4),
    });

export const getTabStyles =
    (isDisabled: boolean) =>
    (theme: Theme): SerializedStyles =>
        css({
            ...(isDisabled && {
                ':hover': {
                    color: theme.palette.gray[600],
                },
            }),
        });
